import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import DiscountNote from "./DiscountNote.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PersonalDiscountNote',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DiscountNote, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "prod-discount__text" }, "Стоимость данного аромата представлена с учетом вашей накопительной скидки", -1 /* HOISTED */)
                ])),
                _: 1 /* STABLE */
            }));
        };
    }
});
